import { SizeProp } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon, FontAwesomeIconProps } from '@fortawesome/react-fontawesome';

interface Props {
    icon: FontAwesomeIconProps['icon'],
    size?: SizeProp,
    iconClassName?: string,
    children?: React.ReactNode,
    title?: string
}

export const Icon = ({
    icon,
    size,
    iconClassName,
    children,
    title,
}: Props): React.ReactElement<any, any> => {
    return (
        <>
            <FontAwesomeIcon icon={icon} size={size} className={iconClassName} title={title} />
            {children && <span className='ms-1'>{children}</span>}
        </>
    );
};
